import { generate, mode } from 'lean-qr';
export function textToBase64Barcode(text: string) {
    const code = generate(text, {
        modes: [
            mode.ascii,
        ],
    })
    return code.toDataURL({
            type: 'image/png',
            pad: 4,
            scale: 1,
        })
}
